import * as yup from "yup";
import type { Asserts } from "yup";

// Response from /user/address validation

const lockerSchema = yup.object({
  id: yup.string().required(),
  name: yup.string().required(),
  address: yup.object({
    country: yup.string().required(),
  }),
});

const addressSchema = yup.object({
  id: yup.string().required(),
  contactName: yup.string().nullable().defined(),
  contactEmail: yup.string().nullable().defined(),
  contactPhone: yup.string().nullable().defined(),
  countryCode: yup.string().nullable().defined(),
  country: yup.string().nullable().defined(),
  city: yup.string().nullable().defined(),
  returnLocker: lockerSchema.nullable().defined(),
  returnLockerId: yup.string().nullable().defined(),
  street: yup.string().nullable().defined(),
  streetNumber: yup.string().nullable().defined(),
  flatNo: yup.string().nullable().defined(),
  zip: yup.string().nullable().defined(),
});

export type TAddressLocker = Asserts<typeof lockerSchema>;

export type TDefaultAddressResponse = Asserts<typeof addressSchema>;

const validateDefaultAddressResponse = (response: any): TDefaultAddressResponse => addressSchema.validateSync(response);

export default validateDefaultAddressResponse;
